import { createContext, useEffect, useState, useRef, useContext } from "react";
import * as signalR from '@microsoft/signalr';
import { AuthContext } from "./AuthContext";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
    const connectionRef = useRef(null);
    const [isConnectionOpen, setIsConnectionOpen] = useState(false);

    const { user } = useContext(AuthContext);

    const [regNums, setRegNums] = useState([]);

    const [rankedCount, setRankedCount] = useState(0);
    const [acceptedCount, setAcceptedCount] = useState(0);
    const [canceledCount, setCanceledCount] = useState(0);

    const [last5RegNums, setLast5RegNums] = useState([]);
    const [recentActivity, setRecentActivity] = useState([]);


    useEffect(() => {

        const connection = new signalR.HubConnectionBuilder()
            .withUrl(process.env.REACT_APP_BACKEND_URL == 'api/' ? "/AdminHub" : 'https://localhost:7127/AdminHub')
            .withAutomaticReconnect()
            .build();

        connection.start()
            .then(() => {
                console.log('Connection established.');
                connectionRef.current = connection;
                subscribeAdminToGroup(user.id);
                setIsConnectionOpen(true)
            })
            .catch(error => {
                console.error('Error establishing connection:', error);
            });

        connection.onreconnecting((error) => {
            console.warn("🔄 Reconnecting...", error);
        });

        connection.onreconnected((connectionId) => {
            console.log("✅ Reconnected!");
        });

        connection.on("ReceiveRegNums", (regNums) => {
            //console.log('Streets: ', address);
            setRegNums(regNums);
        });

        connection.on("ReceiveRankedCount", (count) => {
            setRankedCount(count);
        });

        connection.on("ReceiveAcceptedCount", (count) => {
            setAcceptedCount(count);
        });

        connection.on("ReceiveCanceledCount", (count) => {
            setCanceledCount(count);
        });

        connection.on("ReceiveLastFive", (regNums) => {
            setLast5RegNums(regNums);
        });

        connection.on("ReceiveActions", (actions) => {
            setRecentActivity(actions);
        });

        return () => {
            if (connectionRef.current) {
                connectionRef.current.stop()
                    .then(() => {
                        setRegNums([]);
                        console.log('Connection closed.');
                        setIsConnectionOpen(false)

                    })
                    .catch(error => {
                        console.error('Error while closing connection:', error);
                    });
            }
        };
    }, [])

    const searchRegNums = (searchOptions) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchRegNum", searchOptions)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getRankedCount = (rankingId, schoolId) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchRankedCount", rankingId, schoolId)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getCanceledCount = (rankingId, schoolId) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchCanceledCount", rankingId, schoolId)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getAcceptedCount = (rankingId, schoolId) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SearchAcceptedCount", rankingId, schoolId)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getLastFiveRegs = (schoolId) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("GetLastFiveRegNums", schoolId)
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const getActions = () => {
        if (connectionRef.current) {
            connectionRef.current.invoke("GetLastActions")
                .catch(error => {
                    console.error('Error sending input to SignalR hub:', error);
                });
        }
    };

    const subscribeAdminToGroup = (userId) => {
        if (connectionRef.current) {
            connectionRef.current.invoke("SubscribeToAdminGroup", userId);
        }
    };

    const cleanRegNums = () => {
        setRegNums([]);
    }

    const changeRegNums = (itemId, newValue) => {

        const updatedItems = [...regNums];
        const index = updatedItems.findIndex(item => item.regnumbeR_ID === itemId);

        if (index !== -1) {
            updatedItems[index].status = newValue;
            setRegNums(updatedItems); 
        }

    }

    return (
        <AdminContext.Provider value={{
            regNums,
            searchRegNums,
            cleanRegNums,
            changeRegNums,
            getRankedCount,
            rankedCount,
            acceptedCount,
            canceledCount,
            getCanceledCount,
            getAcceptedCount,
            getLastFiveRegs,
            last5RegNums,
            recentActivity,
            getActions,
            isConnectionOpen
        }}>
            {children}
        </AdminContext.Provider>
    )
}